export const AppRoutes = {
  // pages
  Index: { path: "/" },
  Home: { path: "/home" },
  SignUp: { path: "/signup" },
  SignIn: { path: "/signin" },
  StaffSignIn: { path: "/staff/login" },
}
